<input type="text" [formControl]="valueFormControl" pInputText [placeholder]="placeholderValue" />
